// // export default useBinanceFutures;
// // src/hooks/orderbooks/useBinanceFutures.js
// import { useEffect, useRef, useState } from "react";

// const DEFAULT_PROXY = "";
// const REST_BASE = "https://fapi.binance.com";
// const WS_BASE_RAW = "wss://fstream.binance.com/ws";
// const WS_BASE_COMBINED = "wss://fstream.binance.com/stream";

// /**
//  * Binance USDⓈ-M Futures orderbook hook:
//  * 1) буферим WS diff depth события
//  * 2) тянем REST snapshot (/fapi/v1/depth?symbol=...&limit=...)
//  * 3) режем буфер (u <= lastUpdateId), находим ПЕРВОЕ событие, где U <= lastUpdateId+1 <= u (или pu === lastUpdateId)
//  * 4) применяем все последующие; при GAP → ресинк
//  *
//  * Возвращает: { isConnected, error, orderBook:{asks,bids}, tickerData }
//  */
// export function useBinanceFutures(symbol, {
//   limit = 100,                 // валидно: 5,10,20,50,100,500,1000
//   proxy = DEFAULT_PROXY,       // REST через прокси (CORS)
//   withTicker = false,          // <symbol>@ticker (24h)
//   topN = 20                    // сколько уровней отдаём в UI
// } = {}) {
//   const [isConnected, setIsConnected] = useState(false);
//   const [error, setError]             = useState(null);
//   const [orderBook, setOrderBook]     = useState({ asks: [], bids: [] });
//   const [tickerData, setTickerData]   = useState(null);

//   const wsRef        = useRef(null);
//   const bufferRef    = useRef([]);     // очередь diff событий до применения снапшота
//   const hasSnapRef   = useRef(false);
//   const lastIdRef    = useRef(null);   // lastUpdateId локального стакана
//   const bookRef      = useRef({ asks: [], bids: [] });
//   const rafRef       = useRef(null);

//   // Доп. рефы для борьбы с дублями REST-запросов и дерганиями
//   const snapLockRef  = useRef(false);  // замок, чтобы не тянуть несколько снапшотов одновременно
//   const lastResyncTs = useRef(0);      // анти-дребезг ресинка (по GAP)
//   const initOnceRef  = useRef(false);  // guard для StrictMode (dev)

//   const normSym = (s) => String(s || "").replace(/[-_]/g, "").toUpperCase();
//   const asNum   = (x) => Number.parseFloat(x);

//   const setBookState = () => {
//     if (rafRef.current) cancelAnimationFrame(rafRef.current);
//     rafRef.current = requestAnimationFrame(() => {
//       const asks = [...(bookRef.current.asks || [])]
//         .sort((a, b) => asNum(a[0]) - asNum(b[0]))
//         .slice(0, topN);
//       const bids = [...(bookRef.current.bids || [])]
//         .sort((a, b) => asNum(b[0]) - asNum(a[0]))
//         .slice(0, topN);
//       setOrderBook({ asks, bids });
//     });
//   };

//   const applyLevels = (levels, side) => {
//     const base = bookRef.current[side] || [];
//     for (const [priceStr, qtyStr] of levels) {
//       const p = asNum(priceStr);
//       const q = asNum(qtyStr);
//       const idx = base.findIndex(([pp]) => asNum(pp) === p);
//       if (q === 0) {
//         if (idx !== -1) base.splice(idx, 1);
//       } else {
//         if (idx !== -1) base[idx] = [priceStr, qtyStr];
//         else base.push([priceStr, qtyStr]);
//       }
//     }
//     bookRef.current[side] = base;
//   };

//   const applyEvent = (evt) => {
//     const lastU = lastIdRef.current;
//     const U = evt.U, u = evt.u, pu = evt.pu ?? null;

//     // строгая проверка непрерывности
//     if (lastU != null) {
//       if (u < lastU) return false; // устаревшее
//       if (pu != null) {
//         if (Number(pu) !== Number(lastU)) throw new Error("GAP_IN_BUFFER");
//       } else {
//         // если pu нет — fallback по [U;u]
//         if (U > lastU + 1) throw new Error("GAP_IN_BUFFER");
//       }
//     }

//     applyLevels(evt.b || [], "bids");
//     applyLevels(evt.a || [], "asks");
//     lastIdRef.current = u;
//     return true;
//   };

//   const fetchSnapshot = async (sym) => {
//     // DEDUPE: если снапшот уже в полёте — ничего не делаем
//     if (snapLockRef.current) return;
//     snapLockRef.current = true;

//     try {
//       const restUrl = `${REST_BASE}/fapi/v1/depth?symbol=${sym}&limit=${limit}`;
//       const url = proxy ? `${proxy}/${restUrl}` : restUrl;

//       const res = await fetch(url);
//       if (!res.ok) throw new Error(`Binance FUT depth HTTP ${res.status}`);
//       const js = await res.json();

//       const { lastUpdateId, bids, asks } = js || {};
//       if (!lastUpdateId || !Array.isArray(bids) || !Array.isArray(asks)) {
//         throw new Error("Bad snapshot payload");
//       }

//       // ставим снапшот локально
//       bookRef.current    = { bids: [...bids], asks: [...asks] };
//       lastIdRef.current  = Number(lastUpdateId);
//       hasSnapRef.current = true;
//       setBookState();

//       // 1) срежем буфер (оставим только u > lastUpdateId)
//       bufferRef.current = bufferRef.current.filter(
//         (e) => Number(e.u) > Number(lastIdRef.current)
//       );

//       if (!bufferRef.current.length) return;

//       // 2) найдём ПЕРВОЕ событие, покрывающее lastUpdateId+1
//       const targetIdx = bufferRef.current.findIndex((e) => {
//         const U = Number(e.U), u = Number(e.u), pu = e.pu != null ? Number(e.pu) : null;
//         if (pu != null) return pu === Number(lastIdRef.current);
//         return U <= Number(lastIdRef.current) + 1 && u >= Number(lastIdRef.current) + 1;
//       });

//       if (targetIdx === -1) {
//         // нет события, которое стыкуется со снапшотом → ресинк
//         throw new Error("GAP_IN_BUFFER");
//       }

//       // 3) применяем с targetIdx и далее
//       for (let i = targetIdx; i < bufferRef.current.length; i++) {
//         applyEvent(bufferRef.current[i]);
//       }
//       bufferRef.current = [];
//       setBookState();
//     } finally {
//       snapLockRef.current = false; // освободим замок в любом случае
//     }
//   };

//   useEffect(() => {
//     const sym = normSym(symbol);
//     if (!sym) return;

//     // --- StrictMode guard (только в деве): второй «тренировочный» заход эффекта не выполняем
//     if (process.env.NODE_ENV !== "production") {
//       if (initOnceRef.current) return;
//       initOnceRef.current = true;
//     }

//     setIsConnected(false);
//     setError(null);
//     setOrderBook({ asks: [], bids: [] });
//     setTickerData(null);

//     // сброс локальных структур
//     bufferRef.current   = [];
//     hasSnapRef.current  = false;
//     lastIdRef.current   = null;
//     bookRef.current     = { asks: [], bids: [] };
//     snapLockRef.current = false;

//     // формируем список потоков (futures)
//     const streams = [ `${sym.toLowerCase()}@depth@100ms` ];
//     if (withTicker) streams.push(`${sym.toLowerCase()}@ticker`);

//     // ВАЖНО: для нескольких потоков — только combined URL
//     const wsUrl =
//       streams.length === 1
//         ? `${WS_BASE_RAW}/${streams[0]}`
//         : `${WS_BASE_COMBINED}?streams=${streams.join("/")}`;

//     const ws = new WebSocket(wsUrl);
//     wsRef.current = ws;

//     ws.onopen = () => {
//       setIsConnected(true);
//     };

//     ws.onerror = (e) => {
//       setError(e?.message || "WS error");
//       setIsConnected(false);
//     };

//     ws.onclose = () => {
//       setIsConnected(false);
//     };

//     ws.onmessage = async (ev) => {
//       try {
//         const m = JSON.parse(ev.data);
//         const data = m?.data ?? m; // combined оборачивает: {stream, data}

//         // 24h ticker (по желанию)
//         if (withTicker && data?.e === "24hrTicker") {
//           setTickerData((td) => ({
//             ...(td || {}),
//             symbol: data.s,
//             lastPrice: data.c,
//             volume: data.q,
//             volume24: data.q,
//             bid: orderBook?.bids?.[0]?.[0] || null,
//             ask: orderBook?.asks?.[0]?.[0] || null,
//           }));
//           return;
//         }

//         // diff depth
//         if (data?.e === "depthUpdate") {
//           const evt = {
//             U: Number(data.U),
//             u: Number(data.u),
//             pu: data.pu != null ? Number(data.pu) : null, // у фьюч есть pu — используем!
//             b: data.b || [],
//             a: data.a || [],
//           };

//           // До снапшота — только буферим. Снапшот тянем ОДИН раз (через snapLockRef).
//           if (!hasSnapRef.current) {
//             bufferRef.current.push(evt);
//             if (bufferRef.current.length === 1) {
//               try {
//                 await fetchSnapshot(sym); // замок не даст дернуть повторно
//               } catch {
//                 // сбросим состояние, попробуем снова на следующем ивенте
//                 bufferRef.current = [];
//                 hasSnapRef.current = false;
//                 lastIdRef.current  = null;
//                 bookRef.current    = { asks: [], bids: [] };
//                 snapLockRef.current = false;
//               }
//             }
//             return;
//           }

//           // После снапшота — применяем; при разрыве → ресинк (но не чаще, чем раз в 500 мс)
//           try {
//             const applied = applyEvent(evt);
//             if (applied) setBookState();
//           } catch (e) {
//             if (String(e?.message).includes("GAP_IN_BUFFER")) {
//               const now = Date.now();
//               if (now - lastResyncTs.current > 500) {
//                 lastResyncTs.current = now;
//                 bufferRef.current = [];
//                 hasSnapRef.current = false;
//                 lastIdRef.current  = null;
//                 bookRef.current    = { asks: [], bids: [] };
//                 try {
//                   await fetchSnapshot(sym); // снова всего один запрос благодаря замку
//                 } catch {}
//               }
//             }
//           }
//         }
//       } catch {}
//     };

//     return () => {
//       try { ws.close(); } catch {}
//       wsRef.current = null;
//       if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null; }
//       // Разрешим повторный запуск при смене deps даже в dev
//       if (process.env.NODE_ENV !== "production") {
//         initOnceRef.current = false;
//       }
//     };
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [symbol, limit, proxy, withTicker, topN]);

//   return { isConnected, error, orderBook, tickerData };
// }

// export default useBinanceFutures;
// src/hooks/orderbooks/useBinanceFutures.js
import { useEffect, useRef, useState } from "react";

const DEFAULT_PROXY = "";
const REST_BASE = "https://fapi.binance.com";
const WS_BASE_RAW = "wss://fstream.binance.com/ws";
const WS_BASE_COMBINED = "wss://fstream.binance.com/stream";

export function useBinanceFutures(symbol, {
  limit = 100,
  proxy = DEFAULT_PROXY,
  withTicker = false,
  topN = 20
} = {}) {
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError]             = useState(null);
  const [orderBook, setOrderBook]     = useState({ asks: [], bids: [] });
  const [tickerData, setTickerData]   = useState(null);

  const wsRef           = useRef(null);
  const bufferRef       = useRef([]);
  const hasSnapRef      = useRef(false);
  const lastIdRef       = useRef(null);
  const bookRef         = useRef({ asks: [], bids: [] });
  const rafRef          = useRef(null);

  // guards
  const snapLockRef     = useRef(false);
  const snapshotDoneRef = useRef(false); // <- делаем снапшот только один раз
  const initOnceRef     = useRef(false); // StrictMode guard (dev)

  const normSym = (s) => String(s || "").replace(/[-_]/g, "").toUpperCase();
  const asNum   = (x) => Number.parseFloat(x);

  const setBookState = () => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      const asks = [...(bookRef.current.asks || [])]
        .sort((a, b) => asNum(a[0]) - asNum(b[0]))
        .slice(0, topN);
      const bids = [...(bookRef.current.bids || [])]
        .sort((a, b) => asNum(b[0]) - asNum(a[0]))
        .slice(0, topN);
      setOrderBook({ asks, bids });
    });
  };

  const applyLevels = (levels, side) => {
    const base = bookRef.current[side] || [];
    for (const [priceStr, qtyStr] of levels) {
      const p = asNum(priceStr);
      const q = asNum(qtyStr);
      const idx = base.findIndex(([pp]) => asNum(pp) === p);
      if (q === 0) {
        if (idx !== -1) base.splice(idx, 1);
      } else {
        if (idx !== -1) base[idx] = [priceStr, qtyStr];
        else base.push([priceStr, qtyStr]);
      }
    }
    bookRef.current[side] = base;
  };

  const applyEvent = (evt) => {
    const lastU = lastIdRef.current;
    const U = evt.U, u = evt.u, pu = evt.pu ?? null;

    if (lastU != null) {
      if (u < lastU) return false;
      if (pu != null) {
        if (Number(pu) !== Number(lastU)) return false; // НЕ ресинкаем — просто игнор
      } else {
        if (U > lastU + 1) return false; // разрыв, игнорим
      }
    }

    applyLevels(evt.b || [], "bids");
    applyLevels(evt.a || [], "asks");
    lastIdRef.current = u;
    return true;
  };

  const fetchSnapshotOnce = async (sym) => {
    if (snapshotDoneRef.current || snapLockRef.current) return;
    snapLockRef.current = true;
    try {
      const restUrl = `${REST_BASE}/fapi/v1/depth?symbol=${sym}&limit=${limit}`;
      const url = proxy ? `${proxy}/${restUrl}` : restUrl;

      const res = await fetch(url, { credentials: "omit" });
      if (!res.ok) throw new Error(`Binance FUT depth HTTP ${res.status}`);
      const js = await res.json();

      const { lastUpdateId, bids, asks } = js || {};
      if (!lastUpdateId || !Array.isArray(bids) || !Array.isArray(asks)) {
        throw new Error("Bad snapshot payload");
      }

      bookRef.current    = { bids: [...bids], asks: [...asks] };
      lastIdRef.current  = Number(lastUpdateId);
      hasSnapRef.current = true;
      snapshotDoneRef.current = true; // <- больше никогда не тянем
      setBookState();

      bufferRef.current = bufferRef.current.filter(
        (e) => Number(e.u) > Number(lastIdRef.current)
      );

      // применим накопленное (что влезает без разрыва)
      for (let i = 0; i < bufferRef.current.length; i++) {
        const ok = applyEvent(bufferRef.current[i]);
        if (!ok) break; // при первом же разрыве дальше не идём
      }
      bufferRef.current = [];
      setBookState();
    } finally {
      snapLockRef.current = false;
    }
  };

  useEffect(() => {
    const sym = normSym(symbol);
    if (!sym) return;

    if (process.env.NODE_ENV !== "production") {
      if (initOnceRef.current) return;
      initOnceRef.current = true;
    }

    setIsConnected(false);
    setError(null);
    setOrderBook({ asks: [], bids: [] });
    setTickerData(null);

    bufferRef.current    = [];
    hasSnapRef.current   = false;
    lastIdRef.current    = null;
    bookRef.current      = { asks: [], bids: [] };
    snapLockRef.current  = false;
    snapshotDoneRef.current = false;

    const streams = [ `${sym.toLowerCase()}@depth@100ms` ];
    if (withTicker) streams.push(`${sym.toLowerCase()}@ticker`);

    const wsUrl =
      streams.length === 1
        ? `${WS_BASE_RAW}/${streams[0]}`
        : `${WS_BASE_COMBINED}?streams=${streams.join("/")}`;

    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      setIsConnected(true);
      // делаем СНАПШОТ ОДИН РАЗ здесь
      fetchSnapshotOnce(sym).catch((e) => {
        setError(e?.message || String(e));
      });
    };

    ws.onerror = (e) => {
      setError(e?.message || "WS error");
      setIsConnected(false);
    };

    ws.onclose = () => {
      setIsConnected(false);
    };

    ws.onmessage = (ev) => {
      try {
        const m = JSON.parse(ev.data);
        const data = m?.data ?? m;

        if (withTicker && data?.e === "24hrTicker") {
          setTickerData((td) => ({
            ...(td || {}),
            symbol: data.s,
            lastPrice: data.c,
            volume: data.q,
            volume24: data.q,
            bid: orderBook?.bids?.[0]?.[0] || null,
            ask: orderBook?.asks?.[0]?.[0] || null,
          }));
          return;
        }

        if (data?.e === "depthUpdate") {
          const evt = {
            U: Number(data.U),
            u: Number(data.u),
            pu: data.pu != null ? Number(data.pu) : null,
            b: data.b || [],
            a: data.a || [],
          };

          if (!hasSnapRef.current) {
            bufferRef.current.push(evt);
            return; // снапшот подтянется только из onopen → fetchSnapshotOnce
          }

          const applied = applyEvent(evt);
          if (applied) setBookState();
        }
      } catch {}
    };

    return () => {
      try { ws.close(); } catch {}
      wsRef.current = null;
      if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null; }
      if (process.env.NODE_ENV !== "production") initOnceRef.current = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbol, limit, proxy, withTicker, topN]);

  return { isConnected, error, orderBook, tickerData };
}

export default useBinanceFutures;
